export function createRandomIdentifierByPattern(pattern = '00000', base = 16) {
	return (pattern).replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(base)
	).toString();
}

export function createRandomIdentifier() {
	return createRandomIdentifierByPattern([1e7] + 1e3 + 4e3 + 8e3 + 1e11, 16);
}
